// Return the parameter in URL.
export function getURLParameter(param) {
  const params = (new URL(document.location)).searchParams;
  return params.get(param);
}

export function gotoTop() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

export function getProperty(o, p, default_value=undefined) {
  if (o.hasOwnProperty(p)) {
    return o[p];
  }
  return default_value;
}

export function loadScript(file_url, async = true, type = "text/javascript") {
    return new Promise((resolve, reject) => {
        try {
            const scriptEle = document.createElement("script");
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = file_url;

            scriptEle.addEventListener("load", (ev) => {
                resolve({ status: true });
            });

            scriptEle.addEventListener("error", (ev) => {
                reject({
                    status: false,
                    message: `Failed to load the script ＄{file_url}`
                });
            });

            document.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};